var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDlpAttFlexibilityGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 4,
    fill: "#14BF96"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.75C18.8555 7.75 22 10.8945 22 14.75C22 18.6328 18.8555 21.75 15 21.75C11.1172 21.75 8 18.6328 8 14.75C8 10.8945 11.1172 7.75 15 7.75ZM18.0078 16.5C18.1992 16.1992 18.0898 15.7891 17.7891 15.625L15.6562 14.3945V11.0312C15.6562 10.6758 15.3555 10.375 15 10.375C14.6172 10.375 14.3438 10.6758 14.3438 11.0312V14.75C14.3438 14.9961 14.4531 15.2148 14.6719 15.3242L17.1328 16.7461C17.2148 16.8008 17.3242 16.8281 17.4609 16.8281C17.6797 16.8281 17.8984 16.7188 18.0078 16.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDlpAttFlexibilityGreen);
export default __webpack_public_path__ + "static/media/DlpAttFlexibilityGreen.915e3081b5ad87527e6f016a8cbe36c3.svg";
export { ForwardRef as ReactComponent };